import * as React from 'react';
import { AlertTriangle } from 'react-feather';
import styled from 'styled-components';
import { space, themeGet } from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';
import H3 from '../typography/H3';

type ErrorProps = StyledSystemProps;

const ErrorCont = styled.div<ErrorProps>`
  ${space};
  height: 100%;
  display: flex;
  border-radius: 4px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${themeGet('colors.putty', '#000')};
`;

const Error: React.FC<ErrorProps> = props => {
  return (
    <ErrorCont data-testid="error-handler" m={4} p={4}>
      <AlertTriangle size={120} color={theme.colors.putty} />
      <H3 mt={4} fontWeight={300}>
        Sorry, something went wrong.
      </H3>
    </ErrorCont>
  );
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.tsx